import React from 'react';
import PropTypes from 'prop-types';

import ClientDocumentsPanel from '../../../components/ClientDocumentsPanel';
import DialogRoundedModal from '../../../components/DialogRoundedModal';

import { ModalBody } from './styles';
import texts from './texts.json';

const ChannelDocumentsModal = ({ isOpen, onClose, channel }) => (
  <DialogRoundedModal
    open={isOpen}
    onClose={onClose}
    title={texts.title}
    fullWidth
    maxWidth="sm"
  >
    <ModalBody>
      <ClientDocumentsPanel
        userId={channel?.userId}
        channelId={channel?.id}
      />
    </ModalBody>
  </DialogRoundedModal>
);

ChannelDocumentsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  channel: PropTypes.shape({ userId: PropTypes.string, id: PropTypes.string }),
};

ChannelDocumentsModal.defaultProps = {
  channel: null,
};

export default ChannelDocumentsModal;
